(function() {
	'use strict';

	angular
		.module('pwc.model')
		.factory('BaseModel', BaseModel);

	BaseModel.$inject = ['$window'];

	function BaseModel($window) {

		return {

			getFormattedDate: function getFormattedDate(dateString){

				// could have been imported as UTC date like 2015-10-17T00:00:00+00:00
				// if we localize date would be off for users by 1 day in the past

				var timeString = $window.moment(dateString).utc().format('hh:mm:ss');

				var isExactlyMidnight = timeString === '12:00:00';

				if (isExactlyMidnight){
					return $window.moment(dateString).utc().format('MMMM D, YYYY');
				}

				return $window.moment(dateString).locale('en').format('MMMM D, YYYY');
			},

			getData: function getData() {
				return angular.fromJson(angular.toJson(this));
			},

			/**
			 * format number as currency
			 * uses numerals current local settings (not always $)
			 * @param number
			 */
			getFormattedCurrency: function getFormattedCurrency(number){
				return $window.numeral(number).format('$0,0.00');
			}

		};

	}

})();
